import React from 'react';
import topImage from '../../assets/images/top-image.png';
import placeMarkImg from '../../assets/images/placemark.svg';
import AnchorLink from "react-anchor-link-smooth-scroll";
import './HeaderContent.styles.scss';

const HeaderContent = () => {

    return (
        <div className='header-container'>
            <div className='container'>
                <div className='header-content-wrapper'>
                    <div className='left-side'>
                        <div className='left-side-title'>Клининговая компания</div>
                        <div className='place-wrapper'>
                            <div className='place-title'>
                                <img src={placeMarkImg} alt="placemarkIco" />
                                <span>работающая на территории Москвы</span>
                            </div>
                        </div>
                        <div className="left-side-description">
                            <span> Уберём аккуратно,
                                избавим Вас от мусора и беспорядка.</span>
                            <span>Почистим мягкую мебель и ковровые покрытия.</span>
                        </div>
                        <button className="button" type="button">
                            <AnchorLink href="#uslugi">Заказать онлайн</AnchorLink>
                        </button>
                    </div>
                    <div className='right-side'>
                        <img src={topImage} alt="topimg" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeaderContent;